// Pure logic only - no Number()/toFixed/Intl (banned outside @taler/domain) and no domain
// import (packages/ui may not depend on @taler/domain). File size is a plain byte count, not
// money, so ordinary float math is fine here; it just can't go through a banned call.

const UNITS = ['B', 'KB', 'MB', 'GB'] as const

/** "1.5 KB", "245 B" - one decimal place, dropped when it would be ".0". */
export function formatFileSize(bytes: number): string {
  let value = bytes
  let unitIndex = 0
  while (value >= 1024 && unitIndex < UNITS.length - 1) {
    value /= 1024
    unitIndex++
  }
  const rounded = Math.round(value * 10) / 10
  const whole = Math.trunc(rounded)
  const tenth = Math.round((rounded - whole) * 10)
  return tenth === 0 ? `${whole} ${UNITS[unitIndex]}` : `${whole}.${tenth} ${UNITS[unitIndex]}`
}

/**
 * Mirrors the native `accept` attribute's own matching rules (extension, exact MIME, or a
 * `type/*` wildcard) - the browser's own file picker already filters by it, but a drag-and-drop
 * bypasses that filter entirely, so this is the client-side check for that path. An empty
 * `accept` matches everything, the same as omitting the attribute.
 */
export function matchesAccept(file: { name: string; type: string }, accept: string): boolean {
  const tokens = accept
    .split(',')
    .map((token) => token.trim().toLowerCase())
    .filter((token) => token !== '')
  if (tokens.length === 0) return true
  const lowerName = file.name.toLowerCase()
  const lowerType = file.type.toLowerCase()
  return tokens.some((token) => {
    if (token.startsWith('.')) return lowerName.endsWith(token)
    if (token.endsWith('/*')) return lowerType.startsWith(token.slice(0, -1))
    return lowerType === token
  })
}
